import { Wrench, Garage, Car, Buildings } from "@phosphor-icons/react";
import { Reveal } from "@/components/site/Reveal";

const PARTNERS = [
  { icon: Wrench, label: "Body Shops" },
  { icon: Garage, label: "Repair Centers" },
  { icon: Car, label: "Used Car Lots" },
  { icon: Buildings, label: "Property Management" },
];

const MARQUEE_WORDS = [
  "Priority Emergency Towing",
  "Auction Transport",
  "Fleet Recovery",
  "Dealership Partner",
  "Damage-Free Flatbed",
  "Rock Hill, SC",
];

export const PartnerBar = () => (
  <section
    id="partners"
    data-testid="partner-section"
    className="relative z-10 bg-[var(--tt-surface)] border-y border-white/10 py-20 md:py-28"
  >
    {/* editorial marquee */}
    <div className="tt-marquee-wrap overflow-hidden mb-16 md:mb-20 select-none">
      <div className="tt-marquee-track">
        {[...MARQUEE_WORDS, ...MARQUEE_WORDS].map((w, i) => (
          <span
            key={i}
            className="font-display uppercase text-3xl md:text-5xl tracking-tight px-6 md:px-10 text-white/10 flex items-center gap-6 md:gap-10"
          >
            {w}
            <span className="text-[var(--tt-green)]/40 text-2xl md:text-4xl">/</span>
          </span>
        ))}
      </div>
    </div>

    <div className="mx-auto max-w-[1400px] px-5 md:px-10 lg:px-16">
      <Reveal>
        <h2 className="font-display uppercase text-center text-3xl md:text-5xl tracking-tighter mb-14 md:mb-16">
          Trusted Partner for <span className="text-[var(--tt-green)]">Local Auto Businesses</span>
        </h2>
      </Reveal>

      <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6">
        {PARTNERS.map((p, i) => {
          const Icon = p.icon;
          return (
            <Reveal key={p.label} delay={i * 0.1}>
              <div
                data-testid={`partner-${p.label.toLowerCase().replace(/\s+/g, "-")}`}
                className="group flex flex-col items-center justify-center gap-5 py-10 md:py-14 border border-white/10 bg-black/30 hover:border-[var(--tt-green)]/50 hover:bg-black/60 transition-colors duration-500"
              >
                <Icon
                  weight="light"
                  className="h-12 w-12 md:h-14 md:w-14 text-zinc-600 grayscale group-hover:text-[var(--tt-green)] group-hover:grayscale-0 group-hover:tt-green-glow transition-all duration-500"
                />
                <span className="font-mono text-xs md:text-sm uppercase tracking-[0.15em] text-zinc-500 group-hover:text-white transition-colors text-center px-2">
                  {p.label}
                </span>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
